import { apiFetch } from './api';

export type SendStatus = 'queued' | 'sent' | 'failed';

export interface SendSummary {
  id: string;
  subject: string;
  to: string[];
  from_email: string;
  from_name: string | null;
  status: SendStatus;
  sent_at: number;
}

export interface SendDetail extends SendSummary {
  draft_id: string | null;
  draft_version: number | null;
  html: string;
  reply_to: string | null;
  error: string | null;
}

export interface SendInput {
  draft_id: string;
  version?: number;
  to: string[];
  from_email: string;
  from_name?: string | null;
  reply_to?: string | null;
  subject?: string;
}

export interface SendResult {
  send_id: string;
  status: SendStatus;
  sent_at?: number;
  error?: string;
}

export async function sendEmail(input: SendInput): Promise<SendResult> {
  return apiFetch<SendResult>('/api/send', {
    method: 'POST',
    json: input,
  });
}

export async function listSends(limit = 50): Promise<SendSummary[]> {
  const data = await apiFetch<{ sends: SendSummary[] }>(`/api/sends?limit=${limit}`);
  return data.sends;
}

export async function getSend(id: string): Promise<SendDetail> {
  return apiFetch<SendDetail>(`/api/sends/${id}`);
}
